"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTopLevelObject = void 0;
const Editor_1 = require("../../../Editor");
function isTopLevelObject(id, schema) {
    if (schema.type !== 'object') {
        return false;
    }
    if (id && id.split(Editor_1.EDITOR_ID_SEPARATOR).length === 2) {
        return true;
    }
    return false;
}
exports.isTopLevelObject = isTopLevelObject;
exports.default = isTopLevelObject;
